import * as _ from 'lodash';
import * as React from 'react';
import { Container, FormGroup, Input, Label, Modal, ModalBody } from 'reactstrap';

import * as BillAdditionsApi from '../../api/billAdditions';

import Localization from '../../config/localization';
import {
  ADMIN_IMPORT_STATUS_COMPLETED,
  IMPORT_GET_PARTNER_INTERVAL,
  IMPORT_STATUS_COMPLETED,
  IMPORT_STATUS_STARTED
} from '../../constants/imports';

import BackButton from '../../components/BackButton';
import CustomFile from '../../components/File';
import FileUpload from '../../components/FileUpload';
import Loader from '../../components/Loader';
import CheckBoxSvg from '../../components/Svg/checkBox';
import CloseSvg from '../../components/Svg/close';
import StopSvg from '../../components/Svg/stop';
import SuccessCheckMarkSvg from '../../components/Svg/successCheckMark';
import WarningSvg from '../../components/Svg/warning';
import TrashSvg from '../../components/Svg/trash';

import Notifications from '../../lib/notifications';
import { DownloadFile, IsArrayNotEmpty, TimeStampToDateAndTime, ToFloat, ToNumber, ToString } from '../../lib/utils';

import './BillAdditions.scss';
import { Routes } from '../../constants/routes';
import { fileExtension } from '../../constants/file';

class BillAdditions extends React.Component<BillAdditions.IProps, BillAdditions.IState> {
  state: BillAdditions.IState = {
    loading: false,
    loadingMessage: '',

    formWasSubmitted: false,
    uploadPercent: 0,
    validatePercent: 0,

    additionBillImportStats: undefined,
    additionImportId: 0,
    deleteAdditionImportId: 0,
    file: undefined,
    invalidFile: false,
    step: 1,

    season: Localization.beneficiaryAddSeasonSelect[1].value as 1
  };

  async componentDidMount() {
    await $('#season').selectmenu({ change: this._setSeason });

    await this._listImportedFiles();

    return this._doValidateFile();
  }

  renderDecontImport = () => {
    if (!this.state.additionBillImportStats) {
      return null;
    }

    const groupBy = _.groupBy(this.state.additionBillImportStats.filter(additionBillImportStats => additionBillImportStats.initials), 'month');

    return Object.keys(groupBy).map(month => {
      const count = this._getImportCount(groupBy[month]);

      if (!count) {
        return null;
      }

      return (
        <div className="d-flex mt-3" key={month}>
          <StopSvg className="m-2" />
          <div className="d-flex justify-content-between my-auto w-100">
            <p className="eon-title eon-middle-grey text-nowrap">
              {Localization.formatString(Localization.billAidsStep3DecontLabel, month, ToString(count, '0'))}
            </p>
          </div>
        </div>
      );
    });
  };

  renderCorrectionImport = () => {
    if (!this.state.additionBillImportStats) {
      return null;
    }

    const groupBy = _.groupBy(this.state.additionBillImportStats, 'month');

    return Object.keys(groupBy).map(month => {
      const count = this._getImportCount(groupBy[month], true);

      if (!count) {
        return null;
      }

      return (
        <div className="d-flex mt-1" key={month}>
          <StopSvg className="m-2" />
          <div className="d-flex justify-content-between my-auto w-100">
            <p className="eon-title eon-middle-grey text-nowrap">
              {Localization.formatString(Localization.billAidsStep3CorrectionsLabel, month, ToString(count, '0'))}
            </p>
          </div>
        </div>
      );
    });
  };

  renderStep1 = () => {
    if (this.state.step !== 1) {
      return null;
    }

    return (
      <FileUpload
        FileChange={this._fileChange}
        RemoveFile={this._removeFile}
        DoUploadFile={this._doUploadFile}
        invalidFile={this.state.invalidFile}
        file={this.state.file}
        errorFeedback={Localization.billAidsStep1FileUploadError}
        dragMessage={Localization.billAidsStep1FileUploadDrag}
        deleteButton={Localization.billAidsStep1DeleteFile}
        uploadButton={Localization.billAidsStep1UploadButton}
      />
    );
  };

  renderStep2 = () => {
    if (this.state.step !== 2 || !this.state.file) {
      return null;
    }

    return (
      <div className="mt-5 mb-3">
        <CustomFile
          fileName={this.state.file.name}
          fileSize={this.state.file.size}
          progressMessage={this._getMessage()}
          progressColor={!(this.state.validatePercent > 0) ? 'eon-red' : 'eon-turquoise'}
          progressValue={this.state.validatePercent > 0 ? this.state.validatePercent : this.state.uploadPercent}
        />

        <div className="mt-4 w-25 pr-4 d-flex">
          <button className={`mx-auto eon-button bg-eon-red eon-white`} onClick={this._removeFile}>
            <span className="px-4">{Localization.billAidsStep2QuitButton}</span>
          </button>
        </div>
      </div>
    );
  };

  renderImportTotal = () => {
    return (
      <div className="d-flex justify-content-between position-relative">
        <p className="eon-title eon-darkgrey strong text-nowrap mr-auto">
          {Localization.formatString(Localization.billAidsStep3TotalLabel, ToString(this._getImportCount() + this._getErrorImportCount()))}
        </p>
      </div>
    );
  };

  renderImportResult = () => {
    return (
      <React.Fragment>
        {this.renderDecontImport()}
        {this.renderCorrectionImport()}
      </React.Fragment>
    );
  };

  renderStep3Ok = () => {
    return (
      <div className="mt-5 mb-3 position-relative">
        <div className="results-container w-100">
          <div className="text-nowrap d-inline-flex align-self-end mb-4">
            <SuccessCheckMarkSvg className="m-auto h-100" />
            <p className="eon-title eon-middle-grey ml-1 mb-0 h-100">{Localization.billAidsStep3SuccessMessage}</p>
          </div>
          {this.renderImportTotal()}
          {this.renderImportResult()}
        </div>
        <div className="mt-4 w-50 pr-4 d-flex">
          <button className="mr-5 eon-button bg-eon-red eon-white" onClick={this._aproveImport}>
            <span className="px-4">{Localization.billAidsStep3ImportButton}</span>
          </button>
          <button className="eon-button bg-eon-white eon-middle-grey ml-5 mr-auto c-pointer" onClick={this._removeFile}>
            <CloseSvg className="my-auto mx-1 align-baseline" />
            <span className="eon-middle-grey underline eon-copy">{Localization.billAidsStep3QuitButton}</span>
          </button>
        </div>
      </div>
    );
  };

  renderStep3Error = (additionBillImportStats = this.state.additionBillImportStats || []) => {
    const error1015 = additionBillImportStats.filter(additionBillImportStat => additionBillImportStat.error1015);
    const error1077 = additionBillImportStats.filter(additionBillImportStat => additionBillImportStat.error1077);
    const error1078 = additionBillImportStats.filter(additionBillImportStat => additionBillImportStat.error1078);
    const error1079 = additionBillImportStats.filter(additionBillImportStat => additionBillImportStat.error1079);

    return (
      <div className="mt-5 mb-3 position-relative">
        <div className="results-container w-100">
          <div className="eon-red d-flex mt-3">
            <WarningSvg className="m-0 mr-2" />
            <p className="eon-title text-nowrap ml-0 mr-auto">{Localization.billAidsStep3FileContainErrors}</p>
          </div>
          <div className="ml-4 pl-3 mt-4">{this.renderImportTotal()}</div>
          <div className="mt-4 d-flex position-relative">
            <CheckBoxSvg className="m-0 mr-2" />
            <p className="eon-title eon-darkgrey text-nowrap ml-0 mr-auto">
              {Localization.formatString(Localization.billAidsStep3CorrectRecords, ToString(this._getImportCount(), '0'))}
            </p>
          </div>
          <div className="ml-4 pl-1">{this.renderImportResult()}</div>
          <div className="eon-red d-flex mt-4">
            <WarningSvg className="m-0 mr-2" />
            <p className="eon-title text-nowrap ml-0 mr-auto">
              {Localization.formatString(Localization.billAidsStep3IncorrectRecords, ToString(this._getErrorImportCount(), '0'))}
            </p>
          </div>

          <div className="ml-4 pl-1">
            {IsArrayNotEmpty(error1015) && (
              <div className="d-flex mt-1">
                <StopSvg className="m-2" />
                <div className="d-flex justify-content-between my-auto w-100">
                  <p className="eon-title eon-middle-grey text-nowrap">
                    {Localization.formatString(
                      Localization.billAdditionsStep3ErrorAdditionNotFound,
                      ToString(this._getErrorImportCount(error1015), '0')
                    )}
                  </p>
                </div>
              </div>
            )}

            {IsArrayNotEmpty(error1077) && (
              <div className="d-flex mt-1">
                <StopSvg className="m-2" />
                <div className="d-flex justify-content-between my-auto w-100">
                  <p className="eon-title eon-middle-grey text-nowrap">
                    {Localization.formatString(
                      Localization.billAidsStep3ErrorQuantumToBig,
                      ToString(this._getErrorImportCount(error1077), '0')
                    )}
                  </p>
                </div>
              </div>
            )}

            {IsArrayNotEmpty(error1078) && (
              <div className="d-flex mt-1">
                <StopSvg className="m-2" />
                <div className="d-flex justify-content-between my-auto w-100">
                  <p className="eon-title eon-middle-grey text-nowrap">
                    {Localization.formatString(
                      Localization.billAidsStep3ErrorRefundToBig,
                      ToString(this._getErrorImportCount(error1078), '0')
                    )}
                  </p>
                </div>
              </div>
            )}

            {IsArrayNotEmpty(error1079) && (
              <div className="d-flex mt-1">
                <StopSvg className="m-2" />
                <div className="d-flex justify-content-between my-auto w-100">
                  <p className="eon-title eon-middle-grey text-nowrap">
                    {Localization.formatString(
                      Localization.billAidsStep3ErrorAidExist,
                      ToString(this._getErrorImportCount(error1079), '0')
                    )}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="mt-5 w-50 pr-4 d-flex">
          <button className="mr-5 eon-button bg-eon-red eon-white" onClick={this._getErrorFile}>
            <span className="px-4">{Localization.billAidsStep3ErrorExportButton}</span>
          </button>
          <button className="eon-button bg-eon-white eon-middle-grey ml-5 mr-auto c-pointer" onClick={this._removeFile}>
            <CloseSvg className="my-auto mx-1 align-baseline" />
            <span className="eon-middle-grey underline eon-copy">{Localization.billAidsStep3QuitButton}</span>
          </button>
        </div>
      </div>
    );
  };

  renderStep3 = (additionBillImportStats = this.state.additionBillImportStats || []) => {
    if (this.state.step !== 3) {
      return null;
    } else if (additionBillImportStats.find(additionBillImportStat => !additionBillImportStat.valid)) {
      return this.renderStep3Error();
    }

    return this.renderStep3Ok();
  };

  renderStep4 = () => {
    if (this.state.step !== 4) {
      return null;
    }

    return (
      <div className="mt-5 mb-3">
        <div className="mb-5 pb-5 w-100">
          <div className="text-nowrap d-inline-flex align-self-end">
            <SuccessCheckMarkSvg className="m-auto h-100" />
            <p className="eon-title eon-middle-grey ml-1 mb-0 h-100">{Localization.billAidsStep4SuccessMessage}</p>
          </div>
        </div>
        <div className="mt-4 w-50 pr-4 d-flex">
          <button className="mr-5 eon-button bg-eon-red eon-white" onClick={this._resetState}>
            <span className="px-4">{Localization.billAidsStep4ImportButton}</span>
          </button>
        </div>
      </div>
    );
  };

  renderTips = () => {
    if (this.state.step !== 1) {
      return null;
    }

    return (
      <div>
        <h6 className="eon-title eon-middle-grey mt-3">{Localization.billAidsTips}</h6>
      </div>
    );
  };

  renderDeleteButton = (dbImport: BillAids.IListImportFile) => {
    return (
      <div className="d-inline-flex my-auto c-pointer ml-auto h-100" onClick={() => this._showDeleteModal(dbImport)}>
        <TrashSvg className="mx-1 mr-2 my-auto" />
      </div>
    );
  };

  renderImports = () => {
    if (!this.state.importedFiles || !this.state.importedFiles.length || this.state.step !== 1) return null;

    return (
      <div className="imports-list position-absolute d-flex flex-column">
        <div className="mb-4 list">
          {this.state.importedFiles.map((dbImport, index) => (
            <CustomFile
              containerClass={index ? 'mt-4' : ''}
              key={dbImport.additionImportId || index}
              fileName={this._getFileName(dbImport)}
              replaceSize={this._getFileDate(dbImport) as string}
              textTruncate={true}
              isReady={this._isReady(dbImport)}
              // downloadButton={this.renderDownloadButton(dbImport)}
              deleteButton={this.renderDeleteButton(dbImport)}
              // progressSubMessage={this.renderProgressSubMessage(dbImport)}
            />
          ))}
        </div>

        <div className="mt-auto">
          <p className="eon-title eon-middle-grey">{Localization.billAidsConfirmInfo}</p>
          <button className="mt-2 eon-button bg-eon-red eon-white" onClick={this._finalizeImportModal}>
            <span className="px-4">{Localization.billAidsConfirmButton}</span>
          </button>
        </div>
      </div>
    );
  };

  render() {
    return (
      <Container className="bill-additions px-5 py-4 my-4">
        <BackButton />

        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        <div className="position-relative">
          <h4 className="mt-5 eon-title eon-red force-wrap">{Localization.billAdditionsTitleImportFile}</h4>
          {this.renderTips()}

          <FormGroup className="mt-4 w-50 pr-2 d-inline-block remove-arrow">
          <Label className="text-nowrap" for="stateBudgetAmount">
            {Localization.beneficiaryAddSeason}
          </Label>
          <fieldset className="eon-select large eon-red">
            <Input
              type="select"
              name="season"
              id="season"
              value={this.state.season}
              onChange={this._setSeason}
              className="d-none eon-select large eon-red"
            >
              {Localization.beneficiaryAddSeasonSelect.map(el=>(<option key={el.value} value={el.value} selected={el.selected}>
                {el.label}
              </option>))}
             
            </Input>
          </fieldset>
        </FormGroup>

          {this.renderStep1()}
          {this.renderStep2()}
          {this.renderStep3()}
          {this.renderStep4()}

          {this.renderImports()}
        </div>

        <Modal isOpen={this.state.showFinalizeImportModal} centered size="lg" toggle={this._finalizeImportModal}>
          <ModalBody className="m-3 mb-2 p-5">
            <div className="mb-3">
              <h4 className="eon-title">{Localization.billAidsFinalizeModalTitle}</h4>
            </div>
            <div className="d-flex my-3">
              <p className="eon-title my-auto h-100">{Localization.billAidsFinalizeModalDescription}</p>
            </div>
            {/* <div className="d-flex my-3">
              <WarningSvg />
              <p className="eon-title my-auto h-100">{Localization.billAidsFinalizeModalInfo}</p>
            </div> */}
            <div className="mt-3">
              <button className="mr-5 eon-button bg-eon-red eon-white" onClick={this._finalizeImport}>
                <span className="px-4">{Localization.billAidsFinalizeModalConfirmButton}</span>
              </button>
              <button className="eon-button bg-eon-white eon-middle-grey ml-5 c-pointer"
                      onClick={this._finalizeImportModal}>
                <CloseSvg className="my-auto mx-1" />
                <span
                  className="eon-middle-grey underline eon-copy">{Localization.billAidsFinalizeModalCancelButton}</span>
              </button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={this.state.showDeleteModal} centered size="lg" toggle={this._deleteImport}>
          <ModalBody className="m-3 mb-2 p-5">
            <div className="mb-3">
              <h4 className="eon-title">{Localization.billAidsDeleteModalTitle}</h4>
            </div>
            <div className="d-flex my-3">
              <p className="eon-title my-auto h-100">{Localization.billAidsDeleteModalDescription}</p>
            </div>
            <div className="d-flex my-3">
              <WarningSvg />
              <p className="eon-title my-auto h-100">{Localization.billAidsDeleteModalInfo}</p>
            </div>
            <div className="mt-3">
              <button className="mr-5 eon-button bg-eon-red eon-white" onClick={this._deleteImport}>
                <span className="px-4">{Localization.billAidsDeleteModalConfirmButton}</span>
              </button>
              <button className="eon-button bg-eon-white eon-middle-grey ml-5 c-pointer"
                      onClick={this._hideDeleteModal}>
                <CloseSvg className="my-auto mx-1" />
                <span
                  className="eon-middle-grey underline eon-copy">{Localization.billAidsDeleteModalCancelButton}</span>
              </button>
            </div>
          </ModalBody>
        </Modal>
      </Container>
    );
  }

  _setSeason = (event: Event | React.ChangeEvent<HTMLInputElement>) => {
    const value = (event && event.target && (event.target as any).value ? ToNumber((event.target as any).value) : undefined) as 0 | 1 | undefined;

    return this.setState({ season: value });
  }

  _showDeleteModal = (dbImport: BillAids.IListImportFile) => {
    return this.setState({ showDeleteModal: true, deleteAdditionImportId: dbImport.additionImportId });
  };

  _getMessage = () => {
    if (this.state.uploadPercent === 100 && !(this.state.validatePercent > 0)) {
      return Localization.billAidsStep2LoadedFile;
    } else if (this.state.validatePercent === 100) {
      return Localization.billAidsStep2ValidatedFile;
    } else if (this.state.validatePercent > 0) {
      return Localization.billAidsStep2ValidateFile;
    }
    return Localization.billAidsStep2LoadingFile;
  };

  _doUploadFile = async (event?: React.MouseEvent<HTMLButtonElement>) => {
    try {
      if (event) {
        event.preventDefault();
      }

      if (!this.state.file) {
        return this.setState({ invalidFile: true, step: 1 });
      }

      await this.setState({ step: 2, importDeleted: false });

      const formData = new FormData();

      formData.append('file', this.state.file);

      await BillAdditionsApi.UploadImportFile(formData, {
        params: {
          season: this.state.season
        },
        onUploadProgress: progress => {
          const value = Math.round((progress.loaded * 100) / progress.total);

          return this.setState({ uploadPercent: ToFloat(value) }, () => this.forceUpdate());
        }
      });

      return this._doValidateFile();
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ step: 1 });
    }
  };

  _listImportedFiles = async () => {
    try {
      const response = await BillAdditionsApi.ListImportFiles();

      return this.setState({ importedFiles: response.data });
    } catch (error) {
      return Notifications.error(error && error.message);
    }
  };

  _doValidateFile = async () => {
    try {
      if (this.state.importDeleted || this.state.loading) {
        return undefined;
      }

      const response = await BillAdditionsApi.GetImportStatus();

      const additionImportId = response.data && response.data.additionImportId;

      if (!additionImportId) {
        return this.setState({ step: 1 });
      }

      const processedRows = ToNumber(response.data && response.data.processedRows);
      const totalRows = ToNumber(response.data && response.data.totalRows);
      const status = ToNumber(response.data && response.data.status);

      const value = Math.round((processedRows * 100) / totalRows);

      const file =
        response.data.fileName || response.data.fileSize
          ? ({ name: response.data.fileName, size: response.data.fileSize } as File)
          : undefined;

      await this.setState({ file, step: 2, validatePercent: ToFloat(value), additionImportId });

      if (status === IMPORT_STATUS_STARTED) {
        return setTimeout(this._doValidateFile, IMPORT_GET_PARTNER_INTERVAL);
      } else if (status === IMPORT_STATUS_COMPLETED) {
        return this.setState({
          additionBillImportStats: response.data && response.data.additionBillImportStats,
          loading: false,
          step: 3
        });
      } else if (status === ADMIN_IMPORT_STATUS_COMPLETED) {
        return this._resetState();
      }

      await this.setState({
        additionImportId: 0,
        file: undefined,
        invalidFile: false,
        step: 1,
        uploadPercent: 0,
        validatePercent: 0
      });

      throw new Error();
    } catch (error) {
      return Notifications.error(error && error.message);
    }
  };

  _resetState = () => {
    return this.setState({
      additionImportId: 0,
      file: undefined,
      invalidFile: false,
      step: 1,
      uploadPercent: 0,
      validatePercent: 0
    });
  };

  _aproveImport = async (event: React.MouseEvent<HTMLButtonElement>) => {
    try {
      event.preventDefault();

      await this.setState({ loading: true });

      await BillAdditionsApi.AproveImport(this.state.additionImportId);

      await this._listImportedFiles();

      await this.setState({ loading: false });

      return this._resetState();
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _finalizeImport = async (event: React.MouseEvent<HTMLButtonElement>) => {
    try {
      event.preventDefault();

      await this.setState({ loading: true });

      if (this.state.importedFiles) {
        const additionsId = this.state.importedFiles.map(dbImport => dbImport.additionImportId);
        await BillAdditionsApi.FinalizeImport(additionsId);
      }

      Notifications.success(Localization.billAidsStep4SuccessMessageComplete);

      return this.props.history.push(Routes.HomePage);
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _getErrorFile = async () => {
    try {
      await this.setState({ loading: true });

      const response = await BillAdditionsApi.GetImportErrorFile(this.state.additionImportId);

      await DownloadFile(response.data, `${Localization.billAidsErrorFileName}${this.state.additionImportId}.${fileExtension}`);

      return this.setState({ loading: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _deleteImport = async () => {
    const additionImportId = this.state.deleteAdditionImportId || this.state.additionImportId;

    await this.setState({ loading: true });

    if (additionImportId) {
      await BillAdditionsApi.DeleteImport(additionImportId);
    }

    await this.setState({
      showDeleteModal: false,
      additionImportId: 0,
      deleteAdditionImportId: 0,
      file: undefined,
      importDeleted: true,
      loading: false,
      step: 1,
      uploadPercent: 0,
      validatePercent: 0
    });

    await this._listImportedFiles();

    await this.setState({ loading: false });

    return this._doValidateFile();
  };

  _removeFile = (event?: React.MouseEvent) => {
    if (event) {
      event.preventDefault();
    }
    return this._deleteImport();
  };

  _fileChange = (event?: React.ChangeEvent<HTMLInputElement>) => {
    if (!event) {
      return undefined;
    }

    event.preventDefault();

    const element = event.currentTarget || event.target || {};

    const file = element.files ? element.files[0] : undefined;
    element.value = '';

    if (!file) {
      return this.setState({ invalidFile: true });
    }

    const allow = element.accept.split(',').find(accept => new RegExp(accept.trim(), 'i').test(file.name));

    if (!allow) {
      return this.setState({ invalidFile: true });
    }

    return this.setState({ file, invalidFile: false });
  };

  _getImportCount = (additionBillImportStats = this.state.additionBillImportStats, skipInitials = false, skipCorrections = false) => {
    if (!additionBillImportStats) {
      return 0;
    }

    const filtredAdditionBillImportStats = additionBillImportStats.filter(additionBillImportStat => additionBillImportStat.valid);

    const mapedAdditionBillImportStats =
      filtredAdditionBillImportStats &&
      filtredAdditionBillImportStats.length > 0 &&
      filtredAdditionBillImportStats.map(
        additionBillImportStat =>
          ToNumber(!skipInitials && additionBillImportStat.initials) + ToNumber(!skipCorrections && additionBillImportStat.corrections)
      );

    if (!mapedAdditionBillImportStats || mapedAdditionBillImportStats.length < 2) {
      return ToNumber(mapedAdditionBillImportStats && mapedAdditionBillImportStats[0]);
    }

    return ToNumber(mapedAdditionBillImportStats.reduce((a, b) => ToNumber(a) + ToNumber(b)));
  };

  _getErrorImportCount = (additionBillImportStats = this.state.additionBillImportStats) => {
    if (!additionBillImportStats) {
      return 0;
    }

    const filtredAdditionBillImportStats = additionBillImportStats.filter(
      additionBillImportStat =>
        additionBillImportStat.error1015 || additionBillImportStat.error1077 || additionBillImportStat.error1078 || additionBillImportStat.error1079
    );

    const mapedAdditionBillImportStats =
      filtredAdditionBillImportStats &&
      filtredAdditionBillImportStats.length &&
      filtredAdditionBillImportStats.map(
        additionBillImportStat =>
          ToNumber(additionBillImportStat.error1015) +
          ToNumber(additionBillImportStat.error1077) +
          ToNumber(additionBillImportStat.error1078) +
          ToNumber(additionBillImportStat.error1079)
      );

    if (!mapedAdditionBillImportStats || mapedAdditionBillImportStats.length < 2) {
      return ToNumber(mapedAdditionBillImportStats && mapedAdditionBillImportStats[0]);
    }

    return ToNumber(mapedAdditionBillImportStats.reduce((a, b) => ToNumber(a) + ToNumber(b)));
  };

  _getFileName = (dbImport: BillAids.IListImportFile) => {
    if (!dbImport) {
      return '';
    }
    return Localization.formatString(Localization.billAidsImportFileName, ToString(dbImport.fileName));
  };

  _isReady = (dbImport: BillAids.IListImportFile) => {
    if (!dbImport) {
      return false;
    }
    return !!(dbImport.totalRows && dbImport.status === ADMIN_IMPORT_STATUS_COMPLETED);
  };

  _getFileDate = (dbImport: BillAids.IListImportFile) => {
    if (!dbImport) {
      return '';
    }
    return Localization.formatString(Localization.billAidsImportFileDate, TimeStampToDateAndTime(new Date(dbImport.createdDate).getTime()));
  };

  _finalizeImportModal = () => {
    return this.setState({ showFinalizeImportModal: !this.state.showFinalizeImportModal });
  };

  _hideDeleteModal = () => {
    return this.setState({ deleteAdditionImportId: 0, showDeleteModal: false });
  };
}

export default BillAdditions;
